import { ERROR_CODE }             from '../00_assets' ;
import { API
       , api_response_t
       , Fetcher
       , kde_api_client_t
       , kde_api_data_sheet_t
       , kde_api_enum_t
       , kde_api_machine_t
       , kde_api_job_t
       , kde_api_job_status_t
       , kde_api_role_t
       , kde_api_mastering_t
       , kde_api_user_t
       , kde_api_workgroup_t
       , REST
       }                          from '../02_api' ;

import { IWorkgroup
       , IClients
       , IJobs }                  from './01_model_app_types' ;


function one_page ( vars: any ) { return Promise.resolve( 1 ) ; }

const hash_with_id = ( id: string ) => ( vars: any ) => 'e' + vars[ id ]
    , hash_with_ids = ( ids: string[] ) => ( vars: any ) => 'e' + ids.map( id => vars[ id ] ).join( '$' ) ;

async function api_response_to_fetcher<T> ( request: Promise< api_response_t > )
{
  const response = await request ;

  if ( response.error.code !== ERROR_CODE.NONE )
       throw response.error.code ;

  return response.data as any as T[] ;
}

export const FACTORY =
{
  WORKGROUPS: new Fetcher< kde_api_workgroup_t, Partial<IWorkgroup> >(
            hash_with_id( 'cloud_id' )
          , ( vars: Partial<IWorkgroup>, page:number ) => 
               api_response_to_fetcher( API.WORKGROUPS( vars.cloud_id! ).list!( ) )
          , one_page
          )

, WORKGROUP_USERS: new Fetcher< kde_api_user_t, Partial<IWorkgroup> >(
            hash_with_ids( [ 'cloud_id', 'workgroup_id' ] )
          , ( vars: Partial<IWorkgroup>, page:number ) => 
               api_response_to_fetcher( API.USERS( vars.cloud_id!, vars.workgroup_id! ).list!( ) )
          , one_page
          )

, MACHINES: new Fetcher< kde_api_machine_t, Partial<IWorkgroup> >(
            hash_with_ids( [ 'cloud_id', 'workgroup_id' ] )
          , ( vars: Partial<IWorkgroup>, page:number ) => 
               api_response_to_fetcher( API.MACHINES( vars.cloud_id!, vars.workgroup_id! ).list!( ) )
          , one_page
          ) 

, CLIENTS: new Fetcher< kde_api_client_t, Partial<IClients> >(
            hash_with_ids( [ 'cloud_id' ] )
          , ( vars: Partial<IClients>, page:number ) => 
               api_response_to_fetcher( API.CLIENTS( vars.cloud_id! ).list!( ) )
          , one_page
          )          
, JOBS:  new Fetcher< kde_api_job_t, Partial<IJobs> >(
            hash_with_ids( [ 'cloud_id' ] )
          , ( vars: Partial<IJobs>, page:number ) => 
               api_response_to_fetcher( API.JOBS( vars.cloud_id! ).list!( ) )
          , one_page
          )

, ROLES          : factory_enum< kde_api_role_t >( API.ROLES )
, JOB_STATUS     : factory_enum< kde_api_job_status_t >( API.JOB_STATUS )
, KEY_APPLICATION: factory_enum< kde_api_enum_t >( API.KEY_APPLICATION )
, MKS_TYPES      : factory_enum< kde_api_enum_t >( API.MKS_TYPES )
, MACHINE_TYPES  : factory_enum< kde_api_enum_t >( API.MACHINE_TYPES )
, DATA_SHEET     : factory_enum< kde_api_data_sheet_t >( API.DATA_SHEET )


, KEY_MASTERING: new Fetcher< kde_api_mastering_t, {cloud_id: number} >(
            hash_with_ids( [ 'cloud_id' ] )
          , ( vars: any, page:number ) => 
               api_response_to_fetcher( API.KEY_MASTERING( vars.cloud_id ).list!( ) )
          , one_page
          )
} ;


function factory_enum<T> ( api: REST )
{
  return new Fetcher< T, {} >(
            ( ) => 'the_only_one'
          , ( vars: any, page:number ) => 
               api_response_to_fetcher( api.list!( ) )
          , one_page
          )

}
